var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hkl-invite" },
    [
      _c(
        "HKLModal",
        {
          ref: "modal",
          attrs: {
            title: _vm.$t("hint.inviteAllUsers"),
            okBtnAction: "yesInvite",
          },
          on: { onOkClick: _vm.inviteClick },
        },
        [
          _c("div", [_vm._v("\n      " + _vm._s(_vm.listTitle) + "\n    ")]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.accountsList, function (account) {
              return _c("li", { key: account.id }, [
                _vm._v("\n        " + _vm._s(account.username) + "\n      "),
              ])
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }